import React from "react";

import Text from "src/components/text";
import { formatTimespent } from "src/services/reports.service";

import { CampaignItem } from "src/types/reports";

import styles from "./campaignCard.module.scss";

interface CampaignCardProps {
  item: CampaignItem;
}

const CampaignCard: React.FC<CampaignCardProps> = ({ item }) => {
  const { name, analytics, key, manualIndex } = item;
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.queryItem}>
          <div className={styles.queryNumber}>{manualIndex}</div>
          <div className={styles.data}>
            <div className={styles.title}>{key}</div>
          </div>
        </div>
      </div>
      <div className={styles.info}>
        <Text text={name || ""} className={styles.title} lines={1} />
        <div className={styles.metrics}>
          <span>{analytics?.views || 0} Views</span>
          <span> {formatTimespent(analytics?.avgTimeSpent || 0)} Avg Time </span>
          <span>{analytics?.assets || 0} Assets</span>
        </div>
      </div>
    </div>
  );
};

export default CampaignCard;
